import React, { useState, useEffect } from "react";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import "./_index.scss";

interface Props {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  setText: any;
  sendData: any;
  image: any[];
  text: string;
}

const BasicModal: React.FC<Props> = ({
  open,
  handleClose,
  image,
  sendData,
  text,
  setText,
}) => {
  const [mainv, setMainv] = useState("");
  const [name, setName] = useState("");

  const getUrl = (file: any) => URL.createObjectURL(file);

  useEffect(() => {
    if (image.length > 0) {
      setMainv(URL.createObjectURL(image[0]));
      setName(image[0].name);
    }
  }, [image]);

  if (!open) return null;

  const handleClose_ = () => {
    handleClose();
    setMainv("");
    setName("");
  };

  return (
    <>
      <div className="modal_backdrop" onClick={handleClose_} />

      <div className="modal_card">
        <div className="modal_header">
          <span className="modal_header_title">
            {image.length} {image.length === 1 ? "file" : "files"} selected
          </span>
          <button className="modal_header_close" onClick={handleClose_}>
            <CloseIcon />
          </button>
        </div>

        <div className="modal_preview">
          {mainv && <img src={mainv} alt={name} />}
        </div>

        {image.length > 1 && (
          <div className="modal_thumbnails">
            {image.map((file, idx) => {
              const link = getUrl(file);
              const isActive = mainv === link;
              return (
                <img
                  key={idx}
                  src={link}
                  alt={file.name}
                  className={`modal_thumb ${isActive ? "active" : ""}`}
                  onClick={() => { setMainv(link); setName(file.name); }}
                />
              );
            })}
          </div>
        )}

        <div className="modal_footer">
          <input
            autoFocus
            className="modal_input"
            type="text"
            value={text}
            placeholder="Add a caption..."
            onChange={(e) => setText(e.target.value)}
          />
          <button
            className="modal_send"
            onClick={(e: any) => { sendData(e); handleClose_(); }}
          >
            <SendIcon />
          </button>
        </div>
      </div>
    </>
  );
};

export default BasicModal;